import React from 'react';
import { Box, Container, Typography, Button, Link } from '@mui/material';
import ClassificationBannerHeader from '../../common/banner/classifactionBannerHeader';
import PageHeader from '../../common/banner/pageHeader';
import NetersFlowDash from '../../common/buttons/netersFlowDash';

export default function FlowStats() {

  const baseRoute = process.env.REACT_APP_BASE_RpmOUTE || '/';
  const imgRoute1 = 'images/netersFlow/stats-1.png';
  const imgRoute2 = 'images/netersFlow/stats-2.png';
  const route1 = baseRoute + imgRoute1;
  const route2 = baseRoute + imgRoute2;
  
  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="Flow (NFGraph)"></PageHeader>
      </Box>
      <Typography variant='h4' 
        sx ={{display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.35em', 
              marginBottom: '10px'}}>
        Stats
      </Typography>
      <NetersFlowDash></NetersFlowDash>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
      <img 
          alt="Stats"
          src={route1}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginTop: '-50em'}}
      />
      <img 
          alt="Stats"
          src={route2}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginTop: '-106em', marginBottom: '-55em' }}
      />
      </Box>
    </Container>
  );
};